export function formatNumber(num) {
  if (typeof num !== "undefined" && num !== null) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  }
  return 0;
}
